<template>
  <div class="articlelist-container">
    <div>
      <a-row>
        <a-col :span="2">
          <bread-crumb />
        </a-col>
        <a-col :span="22">
          <table-search
            :company-data="companyData"
            @onSearch="onSearch"
            @onChangeStatus="onChangeStatus"
            @onChangeType="onChangeType"
            @onChangeCompany="onChangeCompany"
            @onChangeColumns="onChangeColumns"
            @onStartTime="onStartTime"
            @onEndTime="onEndTime"
            @editAndAdd="editAndAdd"
          />
        </a-col>
      </a-row>
    </div>
    <div class="global-table-container">
      <div class="recommend-btn-container">
        <a-button
          type="primary"
          class="recommend-btn"
          :loading="publishLoading"
          @click="handlePublish"
        >
          发布
        </a-button>
        <a-button
          type="primary"
          class="recommend-btn"
          :loading="nopublishLoading"
          @click="handleNopublish"
        >
          取消发布
        </a-button>
        <a-button
          type="primary"
          class="recommend-btn"
          :loading="topLoading"
          @click="handleTop"
        >
          置顶
        </a-button>
        <a-button
          type="primary"
          class="recommend-btn"
          :loading="notopLoading"
          @click="handleNotop"
        >
          取消置顶
        </a-button>
        <a-button
          type="primary"
          class="recommend-btn"
          :loading="recommendLoading"
          @click="handleRecommend"
        >
          推荐
        </a-button>
        <a-button
          type="primary"
          class="recommend-btn"
          :loading="norecommendLoading"
          @click="handleNorecommend"
        >
          取消推荐
        </a-button>
        <a-button
          type="danger"
          class="recommend-btn"
          :loading="delLoading"
          @click="handleDelete"
        >
          删除
        </a-button>
        <span
          v-show="isShowError"
          class="errorMsg"
        >请至少选择一项</span>
      </div>

      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        :row-selection="{
          selectedRowKeys,
          onChange:onchangeCheck,
        }"
        @change="changePage"
      >
        <template
          slot="list_order"
          slot-scope="text, record"
        >
          <editable-cell
            :text="text"
            @change="onCellChange(record.id, 'list_order', $event)"
          />
        </template>
        <template
          slot="thumbnail"
          slot-scope="text, record"
        >
          <img
            :src="record.thumbnail_url"
            alt=""
            width="100px"
            height="100px"
          >
        </template>
        <template
          slot="status"
          slot-scope="text, record"
        >
          {{ record.data.is_top===1?'置顶':'未置顶' }} |
          {{ record.data.status===1?'发布':'未发布' }} |
          {{ record.data.recommended===1?'推荐':'未推荐' }}
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import {columns} from './data/index';
import TableSearch from './components/search';
export default {
  components: {TableSearch},
  data() {
    return {
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      title: '',
      visible: false,
      id: '',
      isShowError: false,
      selectedRowKeys: [],
      recommendLoading: false,
      norecommendLoading: false,
      publishLoading: false,
      nopublishLoading: false,
      topLoading: false,
      notopLoading: false,
      delLoading: false,
      keyword: undefined,
      wstatus: '-1',
      polymorphic_type: '0',
      company_id: '0',
      group_id: '0',
      start_time: undefined,
      end_time: undefined,
      companyData: [{id: 0, name: '所有公司'}],
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData(
      {obj_type: '1',
        page: this.current,
        pageSize: this.pageSize,
        keyword: this.keyword,
        wstatus: this.wstatus,
        polymorphic_type: this.polymorphic_type,
        company_id: this.company_id,
        group_id: this.group_id,
        start_time: this.start_time?this.$Date(this.start_time):undefined,
        end_time: this.end_time?this.$Date(this.end_time):undefined,
      });
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading=true;
      let result = await this.$http.post('/portalPost/getList', params);
      if (result.data.status===1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            name: item.name,
            admin_name: item.admin_name,
            list_order: item.list_order,
            hits: item.hits,
            likes: item.likes,
            favorites: item.favorites,
            thumbnail_url: item.thumbnail_url,
            update_time: this.$Format(item.update_time),
            create_time: this.$Format(item.create_time),
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;

      }
    },
    // 获取企业
    async getCompanyData(url) {
      let result = await this.$http.post(url);
      if (result.data.status === 1) {
        let data = result.data.data.data_list.map((item)=>{return {name: item.team_name?item.team_name:item.companyInfo.qichacha_name, ...item};});
        this.companyData = [...this.companyData, ...data];
      }
    },
    // 搜索
    onSearch(value) {
      this.current=1;
      this.keyword=value;
      this.getTableData(
        {obj_type: '1',
          page: 1,
          pageSize: this.pageSize,
          keyword: this.keyword,
          wstatus: this.wstatus,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          group_id: this.group_id,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
    // 选择状态
    onChangeStatus(value){
      console.log('onChangeStatus -> value', value);
      this.current=1;
      this.wstatus=value;
      this.getTableData(
        {obj_type: '1',
          page: 1,
          pageSize: this.pageSize,
          keyword: this.keyword,
          wstatus: this.wstatus,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          group_id: this.group_id,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
    // 选择企业类型
    async onChangeType(value){
      console.log('onChangeType -> value', value);
      if(value===0){
        this.companyData=[{id: 0, name: '所有公司'}];
      }else if(value===1){
        this.getCompanyData('/company/getCompanyList');
      }else{
        this.getCompanyData('/ServiceProvider/getCompanyList');
      }
      this.current=1;
      this.polymorphic_type=value;
      this.getTableData(
        {obj_type: '1',
          page: 1,
          pageSize: this.pageSize,
          keyword: this.keyword,
          wstatus: this.wstatus,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          group_id: this.group_id,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
    // 选择公司
    onChangeCompany(value){
      console.log('onChangeCompany -> value', value);
      this.current=1;
      this.company_id=value;
      this.getTableData(
        {obj_type: '1',
          page: 1,
          pageSize: this.pageSize,
          keyword: this.keyword,
          wstatus: this.wstatus,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          group_id: this.group_id,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
    // 选择栏目
    onChangeColumns(value){
      console.log('onChangeColumns -> value', value);
      this.current=1;
      this.group_id=value;
      this.getTableData(
        {obj_type: '1',
          page: 1,
          pageSize: this.pageSize,
          keyword: this.keyword,
          wstatus: this.wstatus,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          group_id: this.group_id,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
    // 选择开始时间
    onStartTime(value){
      console.log('onChangeColumns -> value', value);
      this.current=1;
      this.start_time=value;
      this.getTableData(
        {obj_type: '1',
          page: 1,
          pageSize: this.pageSize,
          keyword: this.keyword,
          wstatus: this.wstatus,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          group_id: this.group_id,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
    // 选择结束时间
    onEndTime(value){
      console.log('onChangeColumns -> value', value);
      this.current=1;
      this.end_time=value;
      this.getTableData(
        {obj_type: '1',
          page: this.current,
          pageSize: this.pageSize,
          keyword: this.keyword,
          wstatus: this.wstatus,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          group_id: this.group_id,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });

    },

    // 编辑或新增
    editAndAdd(record) {
      console.log('editAndAdd -> record', record);
      if(record){
        this.data=record;
        this.$router.push({path: '/article/add', query: {id: record.id}});
      }else{
        this.$router.push({path: '/article/add'});
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.hospitalModalForm.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            console.log(values);
            this.btnIsLoading=true;
            let result=await this.$http.post('/Customer/update', {type: this.type, id: this.id, ...values});
            this.btnIsLoading=false;
            if(result.data.status===1){
              this.$message.success('操作成功！');
              this.getTableData(
                {obj_type: '1',
                  page: this.current,
                  pageSize: this.pageSize,
                  keyword: this.keyword,
                  wstatus: this.wstatus,
                  polymorphic_type: this.polymorphic_type,
                  company_id: this.company_id,
                  group_id: this.group_id,
                  start_time: this.start_time?this.$Date(this.start_time):undefined,
                  end_time: this.end_time?this.$Date(this.end_time):undefined,
                });
              this.hospitalVisible = false;
            }
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 删除单个
    async onDelete(record) {
      let result=await this.$http.post('/portalPost/postDel', {id: record.id, status: -1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData(
          {obj_type: '1',
            page: this.current,
            pageSize: this.pageSize,
            keyword: this.keyword,
            wstatus: this.wstatus,
            polymorphic_type: this.polymorphic_type,
            company_id: this.company_id,
            group_id: this.group_id,
            start_time: this.start_time?this.$Date(this.start_time):undefined,
            end_time: this.end_time?this.$Date(this.end_time):undefined,
          });
      }
    },
    // check表格
    onchangeCheck(selectedRowKeys, selectedRows){
      this.selectedRowKeys = selectedRowKeys;
      this.isShowError=false;
      console.log('onchangeCheck -> this.isShowError', this.isShowError);
    },
    // 发布
    async handlePublish() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.publishLoading=true;
      let result = await this.$http.post('/portalPost/postStatus', {
        ids: this.selectedRowKeys,
        status: 1,
      });
      this.publishLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(
          {obj_type: '1',
            page: this.current,
            pageSize: this.pageSize,
            keyword: this.keyword,
            wstatus: this.wstatus,
            polymorphic_type: this.polymorphic_type,
            company_id: this.company_id,
            group_id: this.group_id,
            start_time: this.start_time?this.$Date(this.start_time):undefined,
            end_time: this.end_time?this.$Date(this.end_time):undefined,
          });
      }
    },
    // 取消发布
    async handleNopublish() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.nopublishLoading=true;
      let result = await this.$http.post('/portalPost/postStatus', {
        ids: this.selectedRowKeys,
        status: 0,
      });
      this.nopublishLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(
          {obj_type: '1',
            page: this.current,
            pageSize: this.pageSize,
            keyword: this.keyword,
            wstatus: this.wstatus,
            polymorphic_type: this.polymorphic_type,
            company_id: this.company_id,
            group_id: this.group_id,
            start_time: this.start_time?this.$Date(this.start_time):undefined,
            end_time: this.end_time?this.$Date(this.end_time):undefined,
          });
      }
    },
    // 置顶
    async handleTop() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.topLoading=true;
      let result = await this.$http.post('/portalPost/postTop', {
        ids: this.selectedRowKeys,
        is_top: 1,
      });
      this.topLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(
          {obj_type: '1',
            page: this.current,
            pageSize: this.pageSize,
            keyword: this.keyword,
            wstatus: this.wstatus,
            polymorphic_type: this.polymorphic_type,
            company_id: this.company_id,
            group_id: this.group_id,
            start_time: this.start_time?this.$Date(this.start_time):undefined,
            end_time: this.end_time?this.$Date(this.end_time):undefined,
          });
      }
    },
    // 取消置顶
    async handleNotop() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.notopLoading=true;
      let result = await this.$http.post('/portalPost/postTop', {
        ids: this.selectedRowKeys,
        is_top: 0,
      });
      this.notopLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(
          {obj_type: '1',
            page: this.current,
            pageSize: this.pageSize,
            keyword: this.keyword,
            wstatus: this.wstatus,
            polymorphic_type: this.polymorphic_type,
            company_id: this.company_id,
            group_id: this.group_id,
            start_time: this.start_time?this.$Date(this.start_time):undefined,
            end_time: this.end_time?this.$Date(this.end_time):undefined,
          });
      }
    },


    // 推荐
    async handleRecommend() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.recommendLoading=true;
      let result = await this.$http.post('/portalPost/postRecommended', {
        ids: this.selectedRowKeys,
        recommended: 1,
      });
      this.recommendLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(
          {obj_type: '1',
            page: this.current,
            pageSize: this.pageSize,
            keyword: this.keyword,
            wstatus: this.wstatus,
            polymorphic_type: this.polymorphic_type,
            company_id: this.company_id,
            group_id: this.group_id,
            start_time: this.start_time?this.$Date(this.start_time):undefined,
            end_time: this.end_time?this.$Date(this.end_time):undefined,
          });
      }
    },
    // 取消推荐
    async handleNorecommend() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.norecommendLoading=true;
      let result = await this.$http.post('/portalPost/postRecommended', {
        ids: this.selectedRowKeys,
        recommended: 0,
      });
      this.norecommendLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(
          {obj_type: '1',
            page: this.current,
            pageSize: this.pageSize,
            keyword: this.keyword,
            wstatus: this.wstatus,
            polymorphic_type: this.polymorphic_type,
            company_id: this.company_id,
            group_id: this.group_id,
            start_time: this.start_time?this.$Date(this.start_time):undefined,
            end_time: this.end_time?this.$Date(this.end_time):undefined,
          });
      }
    },
    // 批量删除
    async handleDelete() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.delLoading=true;
      let result = await this.$http.post('/portalPost/postDelMore', {
        ids: this.selectedRowKeys,
      });
      this.delLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(
          {obj_type: '1',
            page: this.current,
            pageSize: this.pageSize,
            keyword: this.keyword,
            wstatus: this.wstatus,
            polymorphic_type: this.polymorphic_type,
            company_id: this.company_id,
            group_id: this.group_id,
            start_time: this.start_time?this.$Date(this.start_time):undefined,
            end_time: this.end_time?this.$Date(this.end_time):undefined,
          });
      }
    },
    // 修改排序
    async onCellChange(id, key, value) {
      let result = await this.$http.post('/portalPost/postOrder', {
        id: id,
        list_order: Number(value),
      });
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getTableData(
          {obj_type: '1',
            page: this.current,
            pageSize: this.pageSize,
            keyword: this.keyword,
            wstatus: this.wstatus,
            polymorphic_type: this.polymorphic_type,
            company_id: this.company_id,
            group_id: this.group_id,
            start_time: this.start_time?this.$Date(this.start_time):undefined,
            end_time: this.end_time?this.$Date(this.end_time):undefined,
          });
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData(
        {obj_type: '1',
          page: this.current,
          pageSize: this.pageSize,
          keyword: this.keyword,
          wstatus: this.wstatus,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          group_id: this.group_id,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.articlelist-container {
  .recommend-btn-container {
    margin-bottom: 10px;
    .recommend-btn {
      margin-right: 10px;
    }
    .errorMsg{
      color: red;
      font-size: 16px;
      margin-left: 10px;
    }
  }
}
</style>
